// Every role a flag can target (FLAG_ROLES in src/server/api/feature-flags.ts).
export const TARGET_OPTIONS = [
  {key: "superadmin", label: "Superadmins"},
  {key: "admin", label: "Admin users"},
  {key: "internal", label: "Internal testers"},
  {key: "designer", label: "Designers"},
  {key: "partner", label: "Partners"},
  {key: "external", label: "External users"},
];

export const EMPTY_FEATURE = {
  key: "",
  name: "",
  description: "",
  targets: {},
};
